export default __webpack_public_path__ + "static/media/greyStar.1e573328.svg";